import { RunQueryFor } from "./runQueryFn";
import { ApiBuilder } from "./apiBuilder";

/**
 * Submit phone number for SMS.
 * @param phone - phone number only digits without +7
 */
export const otpRequestMutationFn = async ({ phone }: { phone: string }) => {
  return await RunQueryFor(ApiBuilder.mutations.otp.index(phone));
};

/**
 * Verify sms code
 * @param phone - phone number only digits without +7 (from initial request)
 * @param code - code from sms
 * @param passport - passport (optional)
 * @param consents - array of selected consents (optional)
 */
export const otpVerificationMutationFn = async ({ phone, code, passport, consents }: { phone: string; code: string; passport?: string; consents?: string[] }) => {
  return await RunQueryFor<{ token: string }>(ApiBuilder.mutations.otp.verifications(phone, code, passport, consents));
};

/**
 * Refresh of expired token
 */
export const tokenRefreshMutationFn = async () => {
  return await RunQueryFor<{ token: string }>(ApiBuilder.mutations.token.refreshment());
};

export interface IPaymentMutationParams {
  operationId: string;
  paymentType: string;
  amount: number;
  paymentInstrumentId: number;
}

export const paymentMutationFn = async ({ operationId, ...rest }: IPaymentMutationParams) => {
  return await RunQueryFor(ApiBuilder.mutations.operations.byId(operationId).payments(rest));
};

export interface IDeviceMutationParams {
  fingerprint: string;
  pin: string;
}

export const addDeviceMutationFn = async ({ pin, fingerprint }: IDeviceMutationParams) => {
  return await RunQueryFor(ApiBuilder.mutations.devices(pin, fingerprint));
};

export const authDeviceMutationFn = async ({ pin, fingerprint }: IDeviceMutationParams) => {
  return await RunQueryFor<{ token: string }>(ApiBuilder.mutations.authenticateDevice(pin, fingerprint));
};

export interface IPaymentCardMutationParams {
  limitId: string;
  email?: string;
}

export const cardIssuanceMutationFn = async ({ limitId, ...rest }: IPaymentCardMutationParams) => {
  return await RunQueryFor(ApiBuilder.mutations.limits.byId(limitId).cardIssuance(rest));
};

export interface ICardOtpVerificationMutationParams {
  limitId: string;
  otp: string;
}
export const cardOtpVerificationMutationFn = async ({ limitId, ...rest }: ICardOtpVerificationMutationParams) => {
  return await RunQueryFor<{ token: string }>(ApiBuilder.mutations.limits.byId(limitId).confirmation(rest));
};

export interface IQRPaymentResponse {
  amount: number;
  currency: string;
  description: string;
  id: number;
  precheckId: string;
}
export const createQrPaymentMutationFn = async ({ qrPayload }: { qrPayload: string }) => {
  return await RunQueryFor<IQRPaymentResponse>(ApiBuilder.mutations.qr.index(qrPayload));
};

export const qrPaymentMutationFn = async ({ paymentId, ...rest }: { paymentId: number; precheckId: string }) => {
  return await RunQueryFor<{ status: string }>(ApiBuilder.mutations.qr.byId(paymentId.toString()).payment(rest));
};

export const paymentLinkMutationFn = async ({ limitId, ...rest }: { limitId: string; amount: number }) => {
  return await RunQueryFor<{ redirectUrl: string }>(ApiBuilder.mutations.limits.byId(limitId).paymentLink(rest));
};

export const limitIdentificationEsiaMutationFn = async ({ limitId, redirectUrl }: { limitId: string; redirectUrl: string }) => {
  return await RunQueryFor<{ url: string }>(ApiBuilder.mutations.limits.byId(limitId).identificationEsia({ redirectUrl }));
};

export interface ISbpPayoutMutationParams {
  limitId: string;
  amount: number;
}

export interface ISbpPayoutResponse {
  payoutId: string;
}

export const sbpPayoutMutationFn = async (params: ISbpPayoutMutationParams) => {
  return await RunQueryFor<ISbpPayoutResponse>(ApiBuilder.mutations.payout.sbp(params));
};
